import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, map, throwError } from "rxjs";
import {
  ApiFailResponse,
  AuthToken,
  IRefreshToken,
} from "src/app/view-model/auth.view-model";
import { environment } from "src/environments/environment";

const ACCESS_KEY = "auth-token";
const REFRESH_KEY = "refresh-token";

@Injectable({
  providedIn: "root",
})
export class TokenStorageService {
  constructor(private http: HttpClient) {}

  signOut(): void {
    window.sessionStorage.clear();
  }

  public saveAuthToken(token: string): void {
    window.sessionStorage.removeItem(ACCESS_KEY);
    window.sessionStorage.setItem(ACCESS_KEY, token);
  }

  public getAuthToken(): string | null {
    return window.sessionStorage.getItem(ACCESS_KEY);
  }

  public saveRefreshToken(refreshToken: any): void {
    window.sessionStorage.removeItem(REFRESH_KEY);
    window.sessionStorage.setItem(REFRESH_KEY, refreshToken);
  }

  public getRefreshToken(): any {
    return window.sessionStorage.getItem(REFRESH_KEY);
  }
  public validateRefreshToken_Expiry(): boolean {
    const token = window.sessionStorage.getItem(REFRESH_KEY);
    if (token != null) return this.validateExpiry(token);
    return false;
  }
  public validateAccessToken_Expiry(): boolean {
    const token = window.sessionStorage.getItem(ACCESS_KEY);
    if (token != null) return this.validateExpiry(token);
    return false;
  }
  private validateExpiry(token: string | null): boolean {
    const expiry = JSON.parse(window.atob(token!.split(".")[1])).exp;
    return Math.floor(new Date().getTime() / 1000) <= expiry;
  }
  public generateToken() {
    const token = this.getRefreshToken();

    const body: IRefreshToken = {
      refreshToken: token,
    };
    return this.http
      .post<AuthToken>(
        `${environment.nextGenAccountsAPIURL}auth/refreshtoken`,
        body
      )
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((error: ApiFailResponse, caught) => {
          return throwError(error);
        })
      );
  }

  getUserDataWithToken() {
    return JSON.parse(window.atob(this.getAuthToken()!.split(".")[1]));
  }
}
